routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  var conf = {
    template: require('./home.html'),
    controller: 'HomeController',
    controllerAs: 'home',
    app: true,
    chat: false,
    resolve: {
      currentUser: ['CurrentCase', 'CurrentUser', 'CaseMap',
        'CurrentCustomer', '$route',
        '$location', '$q',
        (CurrentCase, CurrentUser, CaseMap, CurrentCustomer, $route,
          $location, $q) => {

          let deferred = $q.defer();

          CurrentUser.api.get().then(user => {
            if ($route.current.params.caseId) {

              if ($location.search().finalDestination) {
                $location.search('finalDestination', null);
              }

              $q.all([
                CurrentCase.api.get({
                  caseId: $route.current.params.caseId
                }),
                CaseMap.api.get()
              ]).then(
                () => deferred.resolve(user),
                (response) => deferred.reject(response)
              )

            } else {
              let redirect = !$route.current.params.finalDestination;
              redirect && $location.url(
                user.email ? user.lastCaseId ?
                `/home/${user.lastCaseId}` :
                '/home?finalDestination=true' :
                '/signin'
              )

              CurrentCase.setCase()

              CaseMap.api.get().then(() => {
                deferred.resolve(user)
              })

            }

            // Request customer and account but don't defer promise
            CurrentCustomer.api.get()

          }, () => deferred.reject())

          return deferred.promise;
        }
      ]
    }
  }

  $routeProvider
    .when('/home', conf)
    .when('/home/:caseId', conf)
    .when('/home/:caseId/fact/:factId', conf);
};



// WEBPACK FOOTER //
// ./project/pages/home/home.routes.js